export default __webpack_public_path__ + "static/duval-8f7ed0772d46a7f9c7fe6f4a15b6ff71.jpg";